export const SET_MENU_ACTIVE = 'SET_MENU_ACTIVE';
export const SET_SEARCH_KEYWORD = 'SET_SEARCH_KEYWORD';
export const SET_DOWNLOAD_VISIBLE = 'SET_DOWNLOAD_VISIBLE';
export const SET_ABOUT_VISIBLE = 'SET_ABOUT_VISIBLE';
export const SET_OPERATION_MENU_VISIBLE = 'SET_OPERATION_MENU_VISIBLE';
export const SET_TICK = 'SET_TICK';
export const SET_HOT_LENOVO_VISIBLE = 'SET_HOT_LENOVO_VISIBLE';
export const SET_PINPOP_VISIBLE = 'SET_PINPOP_VISIBLE';
export const SET_PINPOP_CLOSE_VISIBLE = 'SET_PINPOP_CLOSE_VISIBLE';
export const SET_DOWNLOAD_PATH_VISIBLE = 'SET_DOWNLOAD_PATH_VISIBLE';
export const SET_PHONE_VISIBLE = 'SET_PHONE_VISIBLE';
export const SET_CAN_BACK = 'SET_CAN_BACK';
export const SET_CHECK_UPDATE_VISIBLE = 'SET_CHECK_UPDATE_VISIBLE';
export const SET_NEW_VERSION_INFO = 'SET_NEW_VERSION_INFO';
export const SET_IFRAME_VISIBLE = 'SET_IFRAME_VISIBLE';
export const SET_DETAIL_COMMENT_VISIBLE = 'SET_DETAIL_COMMENT_VISIBLE';
export const SET_RELEASE_NOTES_VISIBLE = 'SET_RELEASE_NOTES_VISIBLE';
export const SET_USER_FEEDBACK_VISIBLE = 'SET_USER_FEEDBACK_VISIBLE'; // 用户反馈
export const SET_TOP_IMG_VIDEO_VISIBLE = 'SET_TOP_IMG_VIDEO_VISIBLE'; // 头部图片视频

export const MENUS = [
  'recommend',
  'category',
  'topn',
  'shop',
  'update',
  'uninstall',
  'arecommend',
  'acategory',
  'wprecommend',
  'wpcategory',
  'wpmine',
  'work',
  'education',
  'game/gameSelect',
  'game',
];
export const MENUS_CAN_BACK = ['recommend'];
export const SET_FIRST_RUN = 'SET_FIRST_RUN';
// 5.4 新增安装安卓应用成功提醒 2020-7-8 16:14:49
export const IN_TIME_INSTALLED_SOFT = 'IN_TIME_INSTALLED_SOFT';
// 5.4 菜单上的小红点
export const IS_SHOW_MENU_SPOT = 'IS_SHOW_MENU_SPOT';
// 5.4 是否打开静默安装功能
export const SET_IS_ENABLED_SILENT = 'SET_IS_ENABLED_SILENT';
